import { CarteiraBaseResponse } from "domain/types/_carteira/carteiraBase/carteiraBaseResponse"
import { GET_CATEIRA_USUARIO, CARTEIRA_BASE_CAMPANHA_GET, CARTEIRA_BASE_GET, CARTEIRA_BASE_UPDATE, CarteiraBaseActionTypes, CarteiraBaseState } from "domain/types/_carteira/carteiraBase/carteiraBase"
import { CarteiraBaseCampanhaResponse } from "domain/types/_carteira/carteiraBase/carteiraBaseCampanhaResponse"

const INITIAL_STATE: CarteiraBaseState = {
    CarteiraBase: {} as CarteiraBaseResponse,
    CarteiraBaseCampanha: {} as CarteiraBaseCampanhaResponse,
    CarteiraUsuario: []
}

export function CarteiraBaseReducer(state = INITIAL_STATE, action: CarteiraBaseActionTypes): CarteiraBaseState {
    switch (action.type) {
        case CARTEIRA_BASE_UPDATE:
            return { ...state, CarteiraBase: action.payload }
        case CARTEIRA_BASE_GET:
            return { ...state, CarteiraBase: action.payload }
        case CARTEIRA_BASE_CAMPANHA_GET:
            return { ...state, CarteiraBaseCampanha: action.payload }
        case GET_CATEIRA_USUARIO:
            return { ...state, CarteiraUsuario: action.payload as [] }
        default:
            return state
    }
}